import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      const shouldPreserveScroll = sessionStorage.getItem("preserve-scroll-on-language-switch") === "true";
      const savedScrollY = sessionStorage.getItem("preserve-scroll-on-language-switch-y");

      if (shouldPreserveScroll) {
        sessionStorage.removeItem("preserve-scroll-on-language-switch");
        sessionStorage.removeItem("preserve-scroll-on-language-switch-y");

        const nextScrollY = savedScrollY ? Number(savedScrollY) : 0;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo({ top: Number.isFinite(nextScrollY) ? nextScrollY : 0, left: 0, behavior: "auto" });
          });
        });

        return;
      }
    } catch (error) {
      // Ignore storage issues and fall back to default scroll behavior
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;